"use client";
import React, { useState, useEffect, useRef } from "react";
import { stats } from "@/lib/data";

function CounterItem({ label, value, suffix }: { label: string; value: number; suffix: string }) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1800;
          const steps = 60;
          const increment = value / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= value) {
              setCount(value);
              clearInterval(timer);
            } else {
              setCount(Math.floor(current));
            }
          }, duration / steps);
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return (
    <div ref={ref} className="text-center">
      <div className="text-4xl md:text-5xl font-black text-white mb-2">
        {count}
        <span className="text-2xl md:text-3xl" style={{ color: "#F9A8D4" }}>{suffix}</span>
      </div>
      <p className="text-sm font-medium text-white/70 uppercase tracking-wider">{label}</p>
    </div>
  );
}

export default function StatsSection() {
  return (
    <section className="py-16 gradient-primary relative overflow-hidden">
      {/* Seljuk pattern overlay */}
      <div className="absolute inset-0 seljuk-pattern opacity-20" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
            Rakamlarla MyKonya
          </h2>
          <p className="text-white/70 text-sm">Büyüyen bir topluluk, güçlü bir platform</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {stats.map((s) => (
            <CounterItem key={s.label} label={s.label} value={s.value} suffix={s.suffix} />
          ))}
        </div>
      </div>
    </section>
  );
}